/*
创建者 魏强(2018.2.7)
左侧树形菜单
*/
<template>
  <div
    class="left"
    v-if="data"
  >
    <div id="leftNav">
      <div id="leftNavContainer">
        <div
          id="refinements"
          class="celwidget"
          role="complementary"
          aria-label="过滤结果"
        >

          <div
            class="shoppingEngineSectionHeaders"
            role="heading"
            aria-readonly="true"
          >显示搜索结果：</div>

          <div class="categoryRefinementsSection">
            <h2>分类</h2>
            <ul id="">
              <li
                v-for="(item,index) in category"
                :key="item.key"
              >
                <a
                  href="javascript:void(0)"
                  @click="changeCat(item.key)"
                  :data="index"
                >
                  <span class="refinementLink">{{item.name}}</span>
                  <span class="narrowValue">&nbsp;({{item.doc_count}})</span>
                </a>
              </li>
            </ul>
          </div>

          <div
            class="shoppingEngineSectionHeaders"
            role="heading"
            aria-readonly="true"
          >筛选：</div>
          <h2>品牌</h2>
          <ul id="">
            <li
              v-for="(item,index) in brand"
              :key="item.key"
              class="refinementImage"
            >
              <a
                href="javascript:void(0)"
                @click="changeBrand(item.key)"
              >
                <span class="refinementLink">{{item.name}}</span>
                <span class="narrowValue">&nbsp;({{item.doc_count}})</span>
              </a>
            </li>
          </ul>
          <h2>价格</h2>
          <ul>
            <li
              v-for="(item,index) in pricerange"
              :key="item.key"
            >
              <a
                href="javascript:void(0)"
                @click="changePrice(item.start_price,item.end_price)"
              >
                <span class="refinementLink">{{item.start_price}}-{{item.end_price}}元</span>
                <span class="narrowValue">&nbsp;({{item.doc_count}})</span>
              </a>
            </li>
          </ul>
          <hr
            class="s-wayfinding-rule"
            style="margin:5px 0"
          >
        </div>
      </div>
    </div>

    <!-- 获取商品列表左侧广告 -->
  </div>
</template>
<script>
export default {
  props: ["data"],
  data() {
    return {
      //			brand:this.data.brand.buckets,
      //			category:this.data.category.buckets,
      //			pricerange:this.data.pricerange.buckets
    };
  },
  computed: {
    brand() {
      return this.data.brand.buckets;
    },
    category() {
      return this.data.category.buckets;
    },
    pricerange() {
      return this.data.pricerange.buckets;
    },
  },
  created() {},
  methods: {
    changeCat(key) {
      let query = this.$route.query;
      let cat_id = key;
      query = { ...query, cat_id };
      this.$emit("clickType", query);
      //			this.$router.push({path:"/goods-list",query});
    },
    changeBrand(key) {
      let query = this.$route.query;
      let brandId = key;
      query = { ...query, brandId };
      this.$emit("clickType", query);
      //			this.$router.push({path:"/goods-list",query});
    },
    changePrice(startPrice = "", endPrice = "") {
      let query = this.$route.query;
      query = { ...query, startPrice, endPrice };
      this.$emit("clickType", query);
      //			this.$router.push({path:"/goods-list",query});
    },
  },
};
</script>
<style scoped>
li {
  margin: 3px 0 3px 14px;
}
#leftNavContainer {
}
</style>



// WEBPACK FOOTER //
// module-left-tree.vue?b749a67e